import { createReducer } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import sessionStorage from 'redux-persist/lib/storage/session';

import { SIGN_IN_WITH_AUTH0_USER, SIGN_OUT } from 'constants/redux-actions';

const initState = {};
const persistConfig = { key: 'auth0', storage: sessionStorage };

const auth0Reducer = createReducer(initState, {
  [SIGN_IN_WITH_AUTH0_USER]: (prevState, action) => ({
    ...prevState,
    ...action.payload,
  }),
  [SIGN_OUT]: () => ({
    isSkipped: true,
  }),
});

export default persistReducer(persistConfig, auth0Reducer);
